import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../data/content";
import { Reveal, SectionHead } from "./Reveal";
import { scrollToId } from "../lib/scroll";

export const Services = () => (
  <section id="leistungen" className="relative py-28 lg:py-40 bg-[var(--bg-2)]" data-testid="services-section">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <div className="grid lg:grid-cols-12 gap-8 items-end">
        <div className="lg:col-span-8">
          <SectionHead
            eyebrow="Leistungen"
            lines={["Alles für einen", "überzeugenden Auftritt."]}
            text="Von Amazon-Listing bis Instagram-Story: Jedes Format wird individuell gestaltet und professionell nachbearbeitet – optimiert für den jeweiligen Einsatzzweck."
          />
        </div>
        <Reveal className="lg:col-span-4 lg:pb-24 lg:text-right" delay={0.2}>
          <button onClick={() => scrollToId("kontakt")} className="btn-ghost" data-testid="services-cta">
            Projekt besprechen <ArrowUpRight size={16} />
          </button>
        </Reveal>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 border-t border-l border-[var(--line)]" data-testid="services-grid">
        {SERVICES.map((s, i) => (
          <Reveal key={s.n} delay={(i % 4) * 0.08} y={24}>
            <article className="service-card group relative h-full p-8 lg:p-9 border-r border-b border-[var(--line)] min-h-[280px] flex flex-col" data-testid={`service-card-${i}`}>
              <div className="flex items-start justify-between">
                <span className="font-mono text-[0.65rem] tracking-[0.2em] text-[var(--gold)]">{s.n}</span>
                <ArrowUpRight size={18} className="arrow text-[var(--gold)]" />
              </div>
              <h3 className="font-display text-2xl lg:text-[1.75rem] leading-tight mt-10 text-[var(--text)]">{s.title}</h3>
              <p className="mt-4 text-sm text-[var(--muted)] leading-relaxed">{s.text}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
